import {Injectable} from '@angular/core';
import {BaseService} from './base-service';
import {HttpClient} from '@angular/common/http';
import {ApiService} from './api.service';
import {UserService} from './user.service';
import {constants} from '../shared/constants/constants';
import {catchError, mergeMap} from 'rxjs/operators';
import {Observable, of, throwError} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SmartBridgeService extends BaseService {

    constructor(protected http: HttpClient,
                protected auth: ApiService,
                protected user: UserService
    ) {
        super(http, auth, user);
    }


    getBatterySaverThreshold(): Observable<any> {
        const url = this.API_BASE_URL + constants.api.routes.smartbridge.reportMode.settings;
        return this.http.get(url).pipe(
            mergeMap((res: any) => {
                try {
                    if (!('load_curve_threshold' in res.data)) {
                        return throwError(null);
                    }
                    const thresholdRequested = res.data.load_curve_threshold_requested;
                    const threshold = res.data.load_curve_threshold;
                    if (thresholdRequested === null && threshold != null) {
                        return of(threshold);
                    } else if (thresholdRequested === null && threshold === null) {
                        return of(50);
                    } else {
                        return of(thresholdRequested);
                    }
                } catch (error) {
                    return throwError(error);
                }
            }),
            catchError((error) => {
                console.log(error);
                return of(error);
            })
        );
    }

    setBatterySaverThreshold(value): Observable<any> {
        const url = this.API_BASE_URL + constants.api.routes.smartbridge.reportMode.settings;
        const body = {lc_threshold: value};
        return this.http.put(url, body).pipe(
            catchError((error) => {
                console.log('error');
                return of(null);
            })
        );
    }

}
